import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=5b3d615a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3d615a')) {
      api.createRecord('5b3d615a', component.options)
    } else {
      api.reload('5b3d615a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=5b3d615a&", function () {
      api.rerender('5b3d615a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21dMXK0udbn1r/JS/comp/ErrorMessage.vue"
export default component.exports